import * as types from "./actionTypes";

function voortgangsRapportLoaded(isLoaded, hasValidationErrors) {
	return {
		type: types.VOORTGANGSRAPPORT_LOADED,
		body: {
			hasValidationErrors: hasValidationErrors
		}
	};
}

export function notifyLoadedVoortgangsrapport(isLoaded, hasValidationErrors){
	return function (dispatch) {
		return dispatch(voortgangsRapportLoaded(isLoaded, hasValidationErrors));
	};
}